import type { UtilsTranslations } from './utils.translations.pl.ts';

const unexpectedError = "Une erreur inattendue s'est produite. Merci de réessayer.";

export const utilsTranslations: UtilsTranslations = {
  errors: {
    unexpectedError,
  },
  network: {
    '400_1': unexpectedError,
    '400_6': 'Cette question a déjà reçu une réponse',
    '409_1':
      "Ton quiz est déjà terminé - si tu n'as pas encore reçu de retour, nous te l'enverrons bientôt par e-mail !",
    '409_2': 'Le temps imparti pour le quiz est écoulé',
    '409_3': 'Le nombre autorisé de retours au quiz a été dépassé',
    '409_closed': 'Les candidatures sont closes',
    '403_ip':
      "Le panneau d'administration ne fonctionne que depuis le réseau de l'entreprise. Votre adresse IP ({{ip}}) ne fait pas partie des adresses autorisées : connectez-vous via le VPN ou demandez son ajout.",
    '401': 'Ta session a expiré. Reconnecte-toi.',
    '409': unexpectedError,
    '500': unexpectedError,
    loginError: 'Je ne peux pas te connecter - le jeton est invalide ou a expiré',
  },
};
